module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Regular.woff2?8070997696b1c91905fecba458f96640";